import { CheckOutlined } from "@ant-design/icons";

export const CheckIcon = () => <CheckOutlined rev="true" style={{ marginRight: 5 }} />;